
// region External modules
import $ from "jquery"
import on_domready from "domready"
import log from "plugins/loglevel"
// endregion External modules

// region Private Modules
import DataRetriever from "app/data_retriever"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
// endregion Private Modules

import PicturesAndMap from "concepts/serviced_apartment_buildings/pictures_and_map_browser/tabbed/index"
import ContactRequestBox from "concepts/serviced_apartment_buildings/contact/request/box/index"
import CitiesPublicTransportInfoTable from "concepts/cities/public_transport/info/index"
import TransactionAnalytics from "concepts/neighbourhoods/market_data_overview/index"

import Components_ContactInfo from "./components/contact_info/index"
import Components_ShortenText from "./components/shorten_text/index"

import ListingsShareBar from "concepts/listings/share/bar/index"

import {
  load_and_inject_content as load_and_inject_below_the_fold_section,
} from "./below_the_fold_section"


const init = () => {
  const serviced_apartment_id = DataRetriever.get("serviced-apartment-id")
  const selected_listing_id   = DataRetriever.get("selected-listing-id")

  Components_ContactInfo.init({selected_listing_id: selected_listing_id})
  ContactRequestBox.init()
  PicturesAndMap.init_with_promise()
  .catch((...errors) => {
    log.warn(
      "window.App.Concepts.ServicedApartmentBuildings.PicturesAndMapBrowser.Tabbed.initializeAllMatchingElementsPromise() rejected"
    )
    return errors.forEach((err) => log.warn(err))
  })
  .done()

  ListingsShareBar.create()

  on_domready(() => {
    load_and_inject_below_the_fold_section(serviced_apartment_id)
    .then(() => {
      Components_ShortenText.init()

      WaitObjectByPathPromise("window._spacious_main_css_loaded")
      .then(() => {
        window.spacious_post_tti_tasks = window.spacious_post_tti_tasks || []
        window.spacious_post_tti_tasks.push(() => {
          TransactionAnalytics.init().done()
        })

        return Promise.all([
          CitiesPublicTransportInfoTable.init()
          .then(({maps_promise}) => {
            maps_promise.then((maps) => {
              $(".page-section--below-the-fold-content__section-title")
              .on("click", (e) => {
                const $this = $(e.currentTarget)
                $this.parents(".page-section--below-the-fold-content__section").toggleClass("hide-content")

                maps.forEach((map) => {
                  map.invalidateSize({
                    animate:         false,
                    debounceMoveend: true,
                  })
                })
              })
            })
          }),
        ])
      })
      .done()
    })
    .done()
  })
}


export default {
  init,
}
